import { Link } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Button } from "@/shared/components/ui/Button";
import { Logo } from "@/shared/components/ui/Logo";
import { useMe } from "@/shared/lib/auth";

/**
 * Marketing top bar. Fixed and fully unstyled — no fill, blur, or shadow — so it
 * floats over the page canvas (the sanctioned alternative to `glass-nav` in
 * design.md §8) and, being out of flow, reserves no space above the hero. That
 * lets the `min-h-screen` hero own the full viewport and center its content
 * before the user scrolls. The right-hand CTA is auth-aware: a signed-in visitor
 * gets a direct "Go to app" link; everyone else gets "Sign in" (ghost) and "Sign
 * up" (primary). The consent banner sits at `z-overlay`, so it still layers above
 * this.
 */
export function MarketingHeader() {
  const me = useMe();
  return (
    <header className="fixed inset-x-0 top-0 z-tooltip">
      <Container size="lg" className="flex h-16 items-center justify-between">
        <Logo to="/" />
        {me.data ? (
          <Button asChild>
            <Link to="/app/contacts">Go to app</Link>
          </Button>
        ) : (
          <div className="flex items-center gap-2">
            <Button asChild variant="ghost">
              <Link to="/auth/login">Sign in</Link>
            </Button>
            <Button asChild>
              <Link to="/auth/signup">Sign up</Link>
            </Button>
          </div>
        )}
      </Container>
    </header>
  );
}
